module.exports = __webpack_public_path__ + "img/logo.14efae75.svg";